<template>
  <div class="register-page">
    <div class="bg-orb orb-1"></div>
    <div class="bg-orb orb-2"></div>
    <div class="bg-grid"></div>

    <main class="register-main">
      <div ref="cardRef" class="register-card">
        <div class="card-glow"></div>

        <h1 class="title">欢迎回来</h1>
        <p class="subtitle">请登录您的{{ companyName }}账户以继续</p>

        <el-form
          v-if="loginMode === 'password'"
          ref="loginForm"
          class="form register-form"
          :model="loginForm"
          :rules="rules"
          label-position="top"
          status-icon
          :hide-required-asterisk="true"
          @keyup.enter.native="submitForm()"
          v-loading="loading"
          element-loading-text="正在登陆..."
        >
          <el-form-item prop="terminal" v-show="false">
            <el-input type="terminal" v-model="loginForm.terminal"></el-input>
          </el-form-item>

          <el-form-item prop="userName">
            <template slot="label">
              <div class="form-item-label">
                <span>{{ loginNameLabel }}</span>
              </div>
            </template>
            <el-input
              type="userName"
              v-model="loginForm.userName"
              :placeholder="loginNameInputPlaceholder"
              prefix-icon="el-icon-mobile-phone"
              clearable
              @change="handleUserNameChange"
            ></el-input>
          </el-form-item>

          <el-form-item prop="password">
            <template slot="label">
              <div class="form-item-label">
                <span>密码</span>
                <router-link v-if="containsPhoneMode || containsEmailMode" class="form-item-extra" to="/password/reset"> 忘记密码? </router-link>
              </div>
            </template>
            <el-input
              type="password"
              v-model="loginForm.password"
              placeholder="请输入登录密码"
              prefix-icon="el-icon-lock"
              show-password
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item prop="googleCode" v-if="isShowGoogle">
            <template slot="label">
              <div class="form-item-label">
                <span>谷歌验证码</span>
              </div>
            </template>
            <el-input
              type="password"
              v-model="loginForm.googleCode"
              placeholder="请输入登录密码"
              prefix-icon="el-icon-lock"
              show-password
              clearable
            ></el-input>
          </el-form-item>

          <el-button class="submit-btn" type="primary" :loading="loading" @click="submitForm()">
            立即登录
            <i class="el-icon-right"></i>
          </el-button>
        </el-form>
      </div>
    </main>
  </div>
</template>

<script>
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from "../utils/contant/contant";

export default {
  name: "login",
  components: {},
  data() {
    var checkUsername = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入用户名"));
      }
      callback();
    };
    var checkPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      }
      callback();
    };
    var checkGoogleCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入谷歌验证码"));
      }
      callback();
    };
    return {
      loading: false,
      isAutoLogin: true,
      isShowGoogle: false, // 是否展示谷歌验证输入框
      loginForm: {
        terminal: this.$enums.TERMINAL_TYPE.WEB,
        userName: "",
        password: "",
        googleCode: "" //谷歌验证码
      },
      rules: {
        userName: [
          {
            validator: checkUsername,
            trigger: "blur"
          }
        ],
        password: [
          {
            validator: checkPassword,
            trigger: "blur"
          }
        ],
        googleCode: [
          {
            validator: checkGoogleCode,
            trigger: "blur"
          }
        ]
      },
      // 登录模式切换
      loginMode: "password" // password, qr
    };
  },
  methods: {
    submitForm() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http({
            url: "/login",
            method: "post",
            data: this.loginForm
          })
            .then((data) => {
              localStorage.setItem("isAutoLogin", this.isAutoLogin);
              // 保存密码到
              localStorage.setItem("username", this.loginForm.userName);
              // localStorage.setItem("password", this.loginForm.password);
              // localStorage
              sessionStorage.setItem(ACCESS_TOKEN_KEY, data.accessToken);
              sessionStorage.setItem(REFRESH_TOKEN_KEY, data.refreshToken);
              this.$message.success("登录成功");
              this.$router.push("/home/chat");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 获取cookie、
    getCookie(name) {
      let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      let arr = document.cookie.match(reg);
      if (arr) {
        return unescape(arr[2]);
      }
      return "";
    },
    // 设置cookie,增加到vue实例方便全局调用
    setCookie(name, value) {
      document.cookie = name + "=" + escape(value);
    },
    // 登录模式切换
    toggleLoginMode() {
      if (this.loginMode === "password") {
        this.loginMode = "qr";
      } else {
        this.loginMode = "password";
      }
    },
    goBackToPassword() {
      this.loginMode = "password";
    },
    handleUserNameChange(value) {
      this.checkTwo();
    },
    // 验证账号是否需要二次验证 如果 需要需要加一个谷歌验证码输入框
    checkTwo() {
      const userName = (this.loginForm.userName || "").trim();
      if (!userName) return;

      this.$http({
        url: "/findAuth?name=" + userName,
        params: { name: userName },
        method: "GET"
      })
        .then((res) => {
          console.log("res", res);
          this.isShowGoogle = res.googleAuth || false;
        })
        .catch((e) => {})
        .finally(() => {});
    }
  },
  mounted() {
    // 账号密码
    this.loginForm.userName = localStorage.getItem("username");
    // this.loginForm.password = localStorage.getItem("password");
    // 加载配置
    this.configStore.loadConfig();
    // electron 窗口大小
    window.electronAPI &&
      window.electronAPI.sendEvent("resize", {
        width: 410,
        height: 510,
        maximizable: false
      });
    // 自动登录
    if (localStorage.getItem("isAutoLogin") != null) {
      this.isAutoLogin = JSON.parse(localStorage.getItem("isAutoLogin"));
      if (this.isAutoLogin) {
        this.submitForm();
      }
    }
  },
  computed: {
    loginNamePlaceholder() {
      let mode = this.configStore.registration.mode;
      let strText = "用户名";
      if (mode.includes("phone")) {
        strText += "/手机号";
      }
      if (mode.includes("email")) {
        strText += "/邮箱";
      }
      return strText;
    },
    loginNameLabel() {
      const modes = this.modes;
      if (modes.includes("phone") && !modes.includes("email")) {
        return "手机号";
      }
      if (modes.includes("email") && !modes.includes("phone")) {
        return "邮箱";
      }
      if (modes.includes("phone") || modes.includes("email")) {
        return "账号";
      }
      return "用户名";
    },
    loginNameInputPlaceholder() {
      return `请输入您的${this.loginNamePlaceholder}`;
    },
    containsPhoneMode() {
      return this.modes.includes("phone");
    },
    containsEmailMode() {
      return this.modes.includes("email");
    },
    modes() {
      return this.configStore.registration.mode || [];
    },
    companyLogo() {
      return this.configStore.companyLogo || "";
    },
    companyName() {
      return this.configStore.companyName || "";
    },
    information() {
      return this.configStore.information || "";
    }
  },
  watch: {
    companyName: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$elm.setTitleTip(val);
        }
      }
    }
  }
};
</script>

<style scoped>
.register-page {
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: radial-gradient(circle at 20% 20%, rgba(110, 66, 255, 0.12), transparent 30%),
    radial-gradient(circle at 80% 30%, rgba(36, 176, 255, 0.12), transparent 28%),
    radial-gradient(circle at 60% 85%, rgba(91, 143, 249, 0.1), transparent 30%), linear-gradient(180deg, #edf3fb 0%, #e7eef8 100%);
  padding: 0;
  box-sizing: border-box;
}

.register-main {
  position: relative;
  z-index: 1;
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
}

.bg-grid {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(255, 255, 255, 0.18) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.18) 1px, transparent 1px);
  background-size: 28px 28px;
  mask-image: radial-gradient(circle at center, black 45%, transparent 85%);
  pointer-events: none;
}

.bg-orb {
  position: absolute;
  border-radius: 999px;
  filter: blur(18px);
  opacity: 0.8;
  animation: floatOrb 8s ease-in-out infinite;
  pointer-events: none;
}

.orb-1 {
  width: 220px;
  height: 220px;
  top: 8%;
  left: 12%;
  background: radial-gradient(circle, rgba(96, 101, 255, 0.26), transparent 72%);
}

.orb-2 {
  width: 260px;
  height: 260px;
  right: 10%;
  bottom: 8%;
  background: radial-gradient(circle, rgba(47, 171, 255, 0.22), transparent 72%);
  animation-delay: 1.4s;
}

.register-card {
  position: relative;
  width: 388px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 22px;
  box-shadow: 0 24px 70px rgba(31, 41, 55, 0.12), 0 10px 26px rgba(55, 84, 170, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.9);
  padding: 28px 26px 22px;
  box-sizing: border-box;
  backdrop-filter: blur(18px);
  transform-style: preserve-3d;
}

.card-glow {
  position: absolute;
  top: -80px;
  right: -70px;
  width: 180px;
  height: 180px;
  background: radial-gradient(circle, rgba(92, 123, 255, 0.18), transparent 68%);
  filter: blur(10px);
  pointer-events: none;
}

.title {
  margin: 0;
  text-align: center;
  font-size: 22px;
  line-height: 30px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #26313f;
}

.subtitle {
  margin: 8px 0 22px;
  text-align: center;
  font-size: 12px;
  color: #8c96a7;
  line-height: 1.6;
}

.register-form {
  width: 100%;
}

.register-form >>> .el-form-item {
  margin-bottom: 13px;
}

.register-form >>> .el-form-item__label {
  width: 100%;
  padding: 0 0 8px;
  font-size: 12px;
  line-height: 1;
  color: #8b96a8;
  font-weight: 400;
}

.register-form >>> .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label::before {
  display: none !important;
}

.form-item-label {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.form-item-extra {
  border: none;
  background: transparent;
  padding: 0;
  color: #2d68de;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  margin-left: auto;
  text-decoration: none;
}

.form-item-extra:hover {
  opacity: 0.88;
}

.register-form >>> .el-input__inner {
  height: 42px;
  line-height: 42px;
  border-radius: 4px;
  border: 1px solid #edf0f5;
  box-shadow: none;
  background: #ffffff;
  padding: 0 34px;
  color: #334155;
  font-size: 13px;
  transition: border-color 0.22s ease, box-shadow 0.24s ease;
}

.register-form >>> .el-input__inner:hover {
  border-color: #dbe3ef;
}

.register-form >>> .el-input__inner:focus {
  border-color: rgba(59, 130, 246, 0.42);
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.08);
}

.register-form >>> .el-input__inner::placeholder {
  color: #c0c8d3;
}

.register-form >>> .el-input__prefix {
  left: 12px;
  display: flex;
  align-items: center;
}

.register-form >>> .el-input__prefix .el-input__icon {
  color: #9aa8bb;
  font-size: 15px;
  line-height: 42px;
}

.register-form >>> .el-input__suffix {
  right: 10px;
}

.register-form >>> .el-input__suffix .el-input__icon {
  line-height: 42px;
}

.register-form >>> .el-form-item__error {
  padding-top: 4px;
  font-size: 11px;
}

.submit-btn {
  width: 100%;
  height: 42px;
  margin-top: 20px;
  border: none;
  border-radius: 999px;
  background: linear-gradient(90deg, #1827ff 0%, #3f98f5 100%);
  box-shadow: 0 12px 22px rgba(45, 104, 222, 0.24), inset 0 1px 0 rgba(255, 255, 255, 0.22);
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0;
}

.submit-btn:hover,
.submit-btn:focus {
  background: linear-gradient(90deg, #1222f3 0%, #368ef0 100%);
  box-shadow: 0 14px 26px rgba(45, 104, 222, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.22);
}

.submit-btn .el-icon-right {
  margin-left: 3px;
  font-weight: 700;
}

@keyframes floatOrb {
  0%,
  100% {
    transform: translateY(0px) translateX(0px) scale(1);
  }

  50% {
    transform: translateY(-14px) translateX(8px) scale(1.03);
  }
}

@media (max-width: 480px) {
  .register-main {
    align-items: flex-start;
    padding: 20px 16px;
  }

  .register-card {
    width: 100%;
    max-width: 388px;
    padding: 24px 18px 20px;
    border-radius: 18px;
  }

  .title {
    font-size: 20px;
  }
}
</style>
